module.exports = __webpack_public_path__ + "static/img/a130b994b10d291d9a45fe53cd5f1a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_disable_05.png
// module id = HUSw
// module chunks = 1